function initializeProductSwatches(container) {
  const swatchContainers = container.querySelectorAll('.card-swatches, .color-swatches');
  try { console.log('[Swatches] containers found:', swatchContainers.length); } catch(e) {}

  swatchContainers.forEach(swatchContainer => {
    const swatches = swatchContainer.querySelectorAll('.card-swatch, .color-swatch');
    const productCard = swatchContainer.closest('.product-card');

    if (!productCard) return;

    const cardImage = productCard.querySelector('.product-card-image, .product-card__image');
    const skuElement = productCard.querySelector('.js-product-card-sku');
    const discountBadge = productCard.querySelector('.product-card-discount-badge, .product-card__discount-badge');
    const priceAreas = [
      // Sliders: second/new/related
      {
        strike: productCard.querySelector('.strike-price, .product-price-regular.strike-price'),
        sale: productCard.querySelector('.product-price-sale'),
        regular: productCard.querySelector('.product-price-regular:not(.strike-price)')
      },
      // Collection/Search style
      {
        strike: productCard.querySelector('.product-card__price-compare'),
        sale: productCard.querySelector('.product-card__price--sale, .product-card__price-sale'),
        regular: productCard.querySelector('.product-card__price-regular:not(.product-card__price--sale)')
      }
    ];

    // Unified handler
    const handleSwatch = async (swatch, originEvent) => {
      if (!swatch || !swatchContainer.contains(swatch)) return;
      try { console.log('[Swatches] handle from', originEvent?.type, swatch); } catch(e) {}

        const newImageSrc = swatch.dataset.imgSrc || swatch.dataset.variantImage;
        const newSku = swatch.dataset.sku;
        const priceCents = parseInt(swatch.dataset.price || 'NaN', 10);
        const compareAtCents = parseInt(swatch.dataset.compareAtPrice || 'NaN', 10);
        const priceFormatted = swatch.dataset.priceFormatted;
        const compareFormatted = swatch.dataset.compareAtPriceFormatted;

        // Debug log to detect data issues in local
        try {
          console.debug('[SwatchClick]', {
            productId: productCard?.dataset?.productId,
            variantId: swatch.dataset.variantId,
            img: !!newImageSrc,
            sku: newSku,
            priceCents, compareAtCents,
            priceFormatted, compareFormatted
          });
        } catch (e) {}

        if (newImageSrc && newImageSrc.trim() !== '' && cardImage) {
          cardImage.src = newImageSrc;
        }

        if (newSku && skuElement) {
          skuElement.textContent = newSku;
        }

        // Helper to apply prices to the card consistently
        const applyPrices = (priceCentsIn, compareAtCentsIn) => {
          if (Number.isNaN(priceCentsIn)) return;
          const hasDiscount = !Number.isNaN(compareAtCentsIn) && compareAtCentsIn > priceCentsIn;

          // Consistent formatter with explicit peso symbol
          const formatMXN = (cents) => {
            const n = Number(cents) / 100;
            return `$ ${n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          };
          const priceFmt = formatMXN(priceCentsIn);
          const compareFmt = !Number.isNaN(compareAtCentsIn) ? formatMXN(compareAtCentsIn) : '';

          // Try to rebuild all container HTMLs for consistency (some cards have multiple price containers for responsive views)
          const priceContainers = Array.from(productCard.querySelectorAll('.product-card-price, .product-card__price'));
          if (priceContainers.length > 0) {
            priceContainers.forEach(pc => {
              if (hasDiscount) {
                const raw = ((compareAtCentsIn - priceCentsIn) * 100) / compareAtCentsIn;
                const rounded = Math.round(raw / 5) * 5;
                if (pc.classList.contains('product-card__price')) {
                  // Collection/Search style
                  pc.innerHTML = `
                    <span class="product-card__price-compare">${compareFmt}</span>
                    <span class="product-card__price-regular product-card__price--sale product-card__price-sale">${priceFmt}</span>
                  `;
                } else {
                  // Slider style
                  pc.innerHTML = `
                    <span class="product-price-regular strike-price">${compareFmt}</span>
                    <span class="product-price-sale">${priceFmt}</span>
                  `;
                }
              } else {
                if (pc.classList.contains('product-card__price')) {
                  pc.innerHTML = `<span class="product-card__price-regular">${priceFmt}</span>`;
                } else {
                  pc.innerHTML = `<span class="product-price-regular">${priceFmt}</span>`;
                }
              }
            });

            // Additionally update individual spans in case of duplicated markup
            priceAreas.forEach(area => {
              if (!area) return;
              const strike = area.strike;
              const sale = area.sale;
              const regular = area.regular;
              if (hasDiscount) {
                if (strike) strike.textContent = compareFmt;
                if (sale) sale.textContent = priceFmt;
                else if (regular) regular.textContent = priceFmt;
              } else {
                if (strike) strike.textContent = '';
                if (regular) regular.textContent = priceFmt;
                else if (sale) sale.textContent = priceFmt;
              }
            });

            try {
              const title = productCard.querySelector('.product-card-title, .product-card__title')?.textContent?.trim();
              const dbg = priceContainers[0]?.innerHTML?.trim();
              console.debug('[Swatches] updated card', { title, hasDiscount, html: dbg });
            } catch(e) {}
          } else {
            // Fallback: update by elements if we couldn't find the container
            priceAreas.forEach(area => {
              if (!area) return;
              const strike = area.strike;
              const sale = area.sale;
              const regular = area.regular;

              if (hasDiscount) {
                if (strike) strike.textContent = compareNum || compareFmt;
                if (sale) {
                  sale.textContent = priceNum || priceFmt;
                } else if (regular) {
                  regular.textContent = priceNum || priceFmt;
                }
              } else {
                if (strike) strike.textContent = '';
                if (regular) {
                  regular.textContent = priceNum || priceFmt;
                } else if (sale) {
                  sale.textContent = priceNum || priceFmt;
                }
              }
            });
          }

          // Ensure something visible
          const anyHasText = priceAreas.some(area => {
            return !!(area && ((area.sale && area.sale.textContent.trim()) || (area.regular && area.regular.textContent.trim())));
          });
          if (!anyHasText) {
            const firstArea = priceAreas.find(a => a);
            if (firstArea) {
              if (firstArea.sale) firstArea.sale.textContent = priceFmt;
              else if (firstArea.regular) firstArea.regular.textContent = priceFmt;
            }
          }

          // Update discount badge only (no inline 'Ahorre' label under prices)
          if (discountBadge) {
            if (!Number.isNaN(compareAtCentsIn) && compareAtCentsIn > priceCentsIn) {
              const raw = ((compareAtCentsIn - priceCentsIn) * 100) / compareAtCentsIn;
              const rounded = Math.round(raw / 5) * 5;
              discountBadge.textContent = `${rounded}%`;
            } else {
              discountBadge.textContent = '';
            }
          }

          // Re-apply shortly to outlast any late DOM changes from other scripts
          setTimeout(() => {
            try {
              const againPrice = Number.isNaN(priceCentsIn) ? null : priceCentsIn;
              const againCompare = Number.isNaN(compareAtCentsIn) ? NaN : compareAtCentsIn;
              if (againPrice != null) {
                // Re-run minimal update: set numbers in spans
                const strike = productCard.querySelector('.strike-price, .product-card__price-compare');
                const sale = productCard.querySelector('.product-price-sale, .product-card__price--sale, .product-card__price-sale');
                const regular = productCard.querySelector('.product-price-regular:not(.strike-price), .product-card__price-regular:not(.product-card__price--sale)');
                if (!Number.isNaN(againCompare) && againCompare > againPrice) {
                  if (strike) strike.textContent = compareFmt;
                  if (sale) sale.textContent = priceFmt;
                } else {
                  if (regular) regular.textContent = priceFmt;
                  else if (sale) sale.textContent = priceFmt;
                }
              }
            } catch(e) {}
          }, 50);
        };

        // Update prices if we have variant price data
        if (!Number.isNaN(priceCents)) {
          applyPrices(priceCents, compareAtCents);
        } else {
          // Fallback: fetch product JSON to retrieve variant pricing
          let handle = '';
          const link = productCard.querySelector('.product-card-title, .product-card__title a, .product-card-image-link, .product-card__link');
          if (link && link.getAttribute) {
            const href = link.getAttribute('href') || '';
            const m = href.match(/\/products\/([^\/?#]+)/);
            if (m) handle = m[1];
          }

          const variantId = swatch.dataset.variantId;
          if (handle && variantId) {
            try {
              const res = await fetch(`/products/${handle}.js`);
              const data = await res.json();
              const v = data.variants.find(v => String(v.id) === String(variantId));
              if (v) {
                // product.js returns cents
                let p = Number(v.price);
                let c = Number(v.compare_at_price);
                if (!Number.isFinite(p)) return;
                // Defensive: if values seem like units, convert to cents
                if (p < 1000) p = Math.round(p * 100);
                if (Number.isFinite(c) && c < 1000) c = Math.round(c * 100);
                applyPrices(p, Number.isFinite(c) ? c : NaN);
              }
            } catch (e) {
              console.warn('Failed to fetch product JSON for swatch pricing', handle, e);
            }
          }
        }

        swatchContainer.querySelectorAll('.card-swatch, .color-swatch').forEach(s => s.classList.remove('active', 'selected'));
        swatch.classList.add('active');
    };

    // Event delegation: handle interactions even if swatches re-render
    ['click', 'pointerdown', 'touchend'].forEach(evt => {
      swatchContainer.addEventListener(evt, function(event) {
        const swatch = event.target && event.target.closest && event.target.closest('.card-swatch, .color-swatch');
        if (!swatch) return;
        // Do not stop propagation; keep other listeners working
        handleSwatch(swatch, event);
      }, { passive: true });
    });

    // On load: if price looks empty or zero, initialize it from the selected/first swatch
    setTimeout(async () => {
      try {
        const priceBox = productCard.querySelector('.product-card-price, .product-card__price');
        const text = (priceBox && priceBox.textContent) ? priceBox.textContent.replace(/\s+/g,'') : '';
        const hasDigit = /\d/.test(text);
        const looksZero = /(^|[^\d])0[\.,]?0*($|[^\d])/.test(text); // matches 0 or 0.00
        if (!hasDigit || looksZero) {
          // Prefer first swatch with price > 0
          const all = Array.from(swatchContainer.querySelectorAll('.card-swatch, .color-swatch'));
          let selected = swatchContainer.querySelector('.card-swatch.active, .card-swatch.selected, .color-swatch.active, .color-swatch.selected');
          const priced = all.find(el => {
            const p = parseInt(el.dataset.price || 'NaN', 10);
            return Number.isFinite(p) && p > 0;
          });
          selected = priced || selected || all[0] || null;
          if (selected) {
            await handleSwatch(selected, { type: 'auto-init' });
          }
        }
      } catch(e) {
        console.warn('[Swatches] auto-init failed', e);
      }
    }, 0);

    });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductSwatches(document.body);
});

// Re-initialize for Theme Editor or dynamic section loads
document.addEventListener('shopify:section:load', function(e) {
  initializeProductSwatches(e.target || document.body);
});
document.addEventListener('shopify:section:select', function(e) {
  initializeProductSwatches(e.target || document.body);
});

// Document-level fallback listeners (capture)
['click', 'pointerdown', 'touchend'].forEach(evt => {
  document.addEventListener(evt, function(e) {
    const swatch = e.target && e.target.closest && e.target.closest('.card-swatch, .color-swatch');
    if (!swatch) return;
    try { console.log('[Swatches] document', evt, 'caught', swatch); } catch(e) {}
  }, true);
});
